import { pipe } from '../utils'
import Radium, { keyframes } from './configured-radium'

export ConnectLocation from './connect-location'
export DetectThresholds from './detect-thresholds'
export DetectCompact from './detect-compact'
export SearchParams from './search-params'
export DetectWindowScroll from './detect-window-scroll'
export Price from './price'
export Specs from './specs'
export gtmEvent from './gtm-event'
export LocalVehicle from './local-vehicle'
export withHash from './with-hash'
export withSearch from './with-search'
export withDynamicComponents from './with-dynamic-components'
export withDataComponents from './with-data-components'

export { Radium }
export { keyframes }
export const combineHOCs = pipe

export const withRadium = (...hocs) => combineHOCs(Radium, ...hocs)



// WEBPACK FOOTER //
// ./src/higher-order-components/index.js